// Internal/admin/employee events. For example on Admin, POS actions.
export const INDY_USER_EVENTS = {
  DEVELOPER_ITEM_SELECTED: 'DeveloperItemSelected',
  MODEL_SAVED: (modelTypeName) => `${modelTypeName}Saved`,
  REPORT_ITEM_SELECTED: 'ReportItemSelected',
  REPORTREPORT_SELECTED: 'ReportreportSelected',
  SETTING_ITEM_SELECTED: 'SettingItemSelected',
  STARTED_SUPPORT_VIDEO: 'StartedSupportVideo'
}

// Events triggered by/on behalf of end-user. For example on Consumer, Kiosk, customer orders on POS.
export const CUSTOMER_EVENTS = {
  ADDED_FAVORITE: 'Added Favorite',
  ADDED_USUAL_ORDER: 'Added Usual Order',
  CLICKED_CART_HEADER_ICON: 'Clicked Cart Header Icon',
  CLICKED_CURRENT_ORDER_HEADER_ICON: 'Clicked Current Order Header Icon',
  CLICKED_CAROUSEL_ITEM: 'Clicked Carousel Item',
  CLICKED_HERO: 'Clicked Hero',
  CLICKED_HERO_IMAGE: 'Clicked Hero Image',
  CLICKED_MOVIE: 'Clicked Movie',
  CLICKED_NEWS_ITEM: 'Clicked News Item',
  CLICKED_SHOWING: 'Clicked Showing',
  CLICKED_SITE_SELECTOR: 'Clicked Site Selector',
  CLICKED_SITE_SELECTOR_ON_NAVIGATION: 'Clicked Site Selector On Navigation',
  CLICKED_SOCIAL_ICON: 'Clicked Social Icon',
  CLICKED_USER_MOVIE_BUTTON: 'Clicked User Movie Button',
  CLICKED_BANNER_LINK: 'Clicked Banner Link',
  CLOSED_ACCOUNT_MENU: 'Closed Account Menu',
  CLOSED_MAIN_MENU: 'Closed Main Menu',
  MOVIE_PAGE_CLICKED_POSTER: 'Movie Page Clicked Poster',
  MOVIE_PAGE_TRAILER_BUTTON: 'Movie Page Trailer Button',
  ACTIVITY_PAGE_CLICKED_POSTER: 'Activity Page Clicked Poster',
  ACTIVITY_PAGE_TRAILER_BUTTON: 'Activity Page Trailer Button',
  OPENED_ACCOUNT_MENU: 'Opened Account Menu',
  OPENED_MAIN_MENU: 'Opened Main Menu',
  RATE_MOVIE: 'Rate Movie',
  REMOTE_ORDER_PLACED: 'Remote Order Placed',
  REMOVED_USUAL_ORDER: 'Removed Usual Order',
  SAW_SIGN_IN_TO_SAVE_MOVIE: 'Saw Sign In To Save Movie',
  SHOWTIMES_SELECTED_ALL: 'Showtimes Selected All',
  SHOWTIMES_SELECTED_CUSTOM: 'Showtimes Selected Custom',
  SHOWTIMES_SELECTED_TODAY: 'Showtimes Selected Today',
  SHOWTIMES_SELECTED_TOMORROW: 'Showtimes Selected Tomorrow',
  ACTIVITY_SESSIONS_SELECTED_CUSTOM: 'Activity Sessions Selected Custom',
  ACTIVITY_SESSIONS_SELECTED_TODAY: 'Activity Sessions Selected Today',
  ACTIVITY_SESSIONS_SELECTED_TOMORROW: 'Activity Sessions Selected Tomorrow',
  SUBSCRIBED_TO_MARKETING_LISTS: 'Subscribed To Marketing Lists',
  TOGGLED_MOVIE_BUTTON: 'Toggled Movie Button',
  VIEWED_PAGE: (pageName) => `Viewed ${pageName}`,
  ORDER_STARTED_VIA_QR_CODE: 'Order Started Via QR Code',
  ORDER_RETRIEVED_VIA_QR_CODE: 'Order Retrieved Via QR Code'
}
export default CUSTOMER_EVENTS
